import Et3ATag from "../../../core/et3-a-tag";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Text from "../../../core/et3-text";

const ClientUserName = withLiteObserverAndTheme<{
  userName: string;
  userID: number;
}>((props) => {
  const { theme, userID, userName } = props;
  const { colors, unitX } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="space-between"
      alignItems="center"
      withShadow={false}
      width={290}
      height={80}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3ATag
        href={`/users/advanced?id=${userID}`}
        target="_blank"
        style={{
          color: `${colors.all.lavenderIndigo}`,
          width: 100 * unitX
        }}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={25}
          text={userName}
          isSpan={false}
          color={colors.all.black}
          style={{
            width: 190 * unitX
          }}
        />
      </Et3ATag>
      <Et3ATag
        href={`/users/advanced?id=${userID}`}
        target="_blank"
        style={{
          color: `${colors.all.lavenderIndigo}`,
          width: 100 * unitX
        }}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={25}
          text={`${userID}`}
          isSpan={false}
          color={colors.all.black}
          style={{}}
        />
      </Et3ATag>
    </ET3Div>
  );
});
export default ClientUserName;
